import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { toast } from "sonner";

export function NotificationsBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const prevUnread = useRef(0);
  const timer = useRef(null);

  const fetchN = async () => {
    try {
      const { data: d } = await api.get("/notifications");
      if (d.unread > prevUnread.current && prevUnread.current >= 0 && d.items[0]) {
        toast.info(d.items[0].message);
      }
      prevUnread.current = d.unread;
      setData(d);
    } catch (e) { console.error("Notifications: échec du chargement", e); }
  };

  useEffect(() => {
    fetchN();
    timer.current = setInterval(fetchN, 20000);
    return () => timer.current && clearInterval(timer.current);
  }, []);

  const openChange = async (open) => {
    if (open && data.unread > 0) {
      await api.post("/notifications/read").catch(() => {});
      prevUnread.current = 0;
      setData((d) => ({ ...d, unread: 0 }));
    }
  };

  return (
    <Popover onOpenChange={openChange}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notifications-bell">
          <Bell className="h-5 w-5" />
          {data.unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 bg-destructive text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1" data-testid="notifications-count">
              {data.unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="px-4 py-3 border-b border-border font-display font-semibold text-sm">Notifications</div>
        <div className="max-h-80 overflow-auto divide-y divide-border" data-testid="notifications-list">
          {data.items.length === 0 && <p className="text-sm text-muted-foreground px-4 py-6 text-center">Aucune notification.</p>}
          {data.items.map((n) => (
            <div key={n.id} className={`px-4 py-3 text-sm ${!n.read ? "bg-secondary/50" : ""}`}>
              <p>{n.message}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{new Date(n.created_at).toLocaleString("fr-FR")}</p>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
